import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';
import Group from '@mui/icons-material/Group';
import CheckCircle from '@mui/icons-material/CheckCircle';
import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline';

  

export default function StudentCourseCreditList() {

  const [courseCreditListData, setCourseCreditListData] = useState([]);
  const [internshipDataID, setInternshipDataID] = useState(null);

  const [flag, setflag] = useState(false);
  const [issaved, setissaved] = useState(false);


  const tableRef = useRef(null);

  {/*------------------------------------*/ }
  /* CUSTOM DATA TABLE BEGIN HERE */

  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);


  const [reload, setReload] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [disciplineId, setDisciplineId] = useState(null);
  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [collegedisciplinetype, setCollegeDisciplineTypeChange] = useState(null);

  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [getConfirm, setConfirm] = useState(false);
  const [rejectConfirm, setRejectConfirm] = useState(false);



  /* CUSTOM DATA TABLE END HERE */


  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }


  let cid = localStorage.getItem("id");
  console.log("id==",cid);
  let collegename = localStorage.getItem("username");

  useEffect(() => {
    const getStudentCourseCreditList = async () => {
      try {
        const response = await http.get('College/getStudentCourseCreditList', {

          searchDiscipline: disciplineId || null,

        });

        setCourseCreditListData(response.data.resultData || []);
      } catch (error) {
        console.error("Error fetching internship data");
        toast.error("Error fetching internship data:");
      }
    };
    getStudentCourseCreditList();


  }, []);
  console.log("disciplineId", disciplineId)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.get(`/College/getCollegeDisciplinesfor_SFA_DEO_Panel`, {
          params: {
            limit: '500',
            college_id: cid
          }
        });

        //setDisciplineData(response.data);
        // Check if data is an array
        if (Array.isArray(response.data)) {
          setDisciplineData(response.data);
        } else {
          setDisciplineData([]); // fallback to empty array
        }
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchData();
  }, [reload, cid]);


  const handleDisciplineChange = (selectedOption) => {
    console.log("ok");

    if (selectedOption) {
      setDisciplineId(selectedOption.did);
      setDisciplineNameChange(selectedOption.value);
      setDisciplineTypeChange(selectedOption.type);
      setCollegeDisciplineTypeChange(selectedOption.college_discipline_id);
      console.log("disciplineId==", selectedOption.did);
    }
    else {
      setDisciplineId(null);
      setDisciplineNameChange(null);
      setDisciplineTypeChange(null);
      setCollegeDisciplineTypeChange(null);
    }
  };

  /* DATA TABLE  */

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };


  useEffect(() => {
    const filteredAndSortedData = [...courseCreditListData]
    .filter(item => {
      const text = searchQuery.toLowerCase();

      const searchableText = [
        item.internship_topic,
        item.offered_by_name,
        item.mode_of_study,
        String(item.total_seats),
        item.approve_status,
        //disciplines data  
        item.disciplines?.map(d => d.discipline_name).join(" ")
      ]
        .filter(Boolean)   // remove null/undefined
        .join(" ")         // merge into one string
        .toLowerCase();

      return searchableText.includes(text);
    })
    .sort((a, b) => {
      if (!sortBy.column) return 0;

      if (sortBy.direction === "asc") {
        return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
      } else {
        return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
      }
    });

    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

    setfilteredAndSortedData(paginatedData);
    setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
    setTotal(filteredAndSortedData.length);

  }, [searchQuery, sortBy, courseCreditListData, currentPage]);

  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* DATA TABLE END */



  const handleGeneratePDFNew = async () => {
    // setLoading(true);
    try {
      const response = await http.get('/College/topicListpdfDownload', {
        params: {
          college_id: cid,
          user_type: 22
        },
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `${localStorage.getItem('username')}_${collegename}_InternshipList.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {
      //console.log("error",error);
      // setLoading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);

      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };


  const handleClearFields = () => {
    setDisciplineId(null);
    setDisciplineData([]);
    setDisciplineTypeChange(null);
    setReload(!reload);


  }
  const showConfirm = (id) => {
    setInternshipDataID(id);
    setConfirm(true);
  }
  const showRejectConfirm = (id) => {
    setInternshipDataID(id);
    setRejectConfirm(true);
  }

  const handleCancel = () => {
    setConfirm(false);
  }

  const handleRejectCancel = () => {
    setRejectConfirm(false);
  }

  const handleApprove = () => {

    http.post('/College/Principalforward', {
      id: internshipDataID
    })
      .then((response) => {

        if (response.data.status_code === 'MSG3') {
          setissaved(!issaved);
          setConfirm(false);

          toast.success('Topic Forwarded Successfully');
        }
        else {
          setissaved(!issaved);
          toast.error('Failed to save data');
        }

      })
      .catch((error) => {
        setissaved(!issaved);
        setConfirm(false);

        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        }
        else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/ino/"), 5000);
        }
        else {
          toast.error("Something went wrong");
        }
      });
  };
  const handleReject = () => {

    http.post('/College/Principalrevert', {
      id: internshipDataID
    })
      .then((response) => {

        if (response.data.status_code === 'MSG3') {
          setissaved(!issaved);
          setRejectConfirm(false);

          toast.success('Topic Reverted Successfully');
        }
        else {
          setissaved(!issaved);
          toast.error('Failed to revert');
        }

      })
      .catch((error) => {
        setissaved(!issaved);
        setRejectConfirm(false);


        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        }
        else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/ino/"), 5000);
        }
        else {
          toast.error("Something went wrong");
        }
      });
  };


let uid = localStorage.getItem('id');
console.log("uid",uid);

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      textAlign: 'left', // added

    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
      textAlign: 'left', // added

    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
        textAlign: 'left', // added

      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>External Credit Verification </h5>
                    </div>
                  </div>
                  <div className="card-body">
                    {/* <div className="table-responsive"> */}


                    <div className="table-responsive">

                      <div className="row align-items-center pdg18">
                        {/* Left 6 columns */}
                        <div className="col-md-8">
                          {/* <div className="row align-items-center">
                            <div className="col-md-6">
                              <label>Department/Discipline</label>
                              <Select
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                id="discipline_id"
                                name="discipline_id"
                                className="form"
                                placeholder="Select Department/Discipline"
                                isSearchable={true}
                                isClearable={true}
                                styles={customStyles}
                                onChange={handleDisciplineChange}
                                options={flag
                                  ? [{ value: '0', label: 'No data found' }]
                                  : disciplinedata
                                    .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                    .map(disciplines => ({
                                      did: disciplines.discipline_id,
                                      value: disciplines.discipline_name,
                                      label: disciplines.college_discipline_id == 1
                                        ? `${disciplines.discipline_name} (Single Faculty Course)`
                                        : disciplines.discipline_name,
                                      type: disciplines.college_course_type,
                                      college_discipline_id: disciplines.college_discipline_id
                                    }))
                                }
                                value={
                                  disciplinedata
                                    .map(d => ({
                                      did: d.discipline_id,
                                      value: d.discipline_name,
                                      label: d.college_discipline_id == 1
                                        ? `${d.discipline_name} (Single Faculty Course)`
                                        : `${d.discipline_name}`,
                                      type: d.college_course_type,
                                      college_discipline_id: d.college_discipline_id
                                    }))
                                    .find(option => option.did == disciplineId && option.type == disciplinetype) || null
                                }
                              />
                            </div>

                            <div className="col-md-6 d-flex align-self-end">
                              <button
                                type="button"
                                className="btn btn-secondary clear-btn ms-2"
                                onClick={handleClearFields}
                              >
                                Clear
                              </button>
                            </div>
                          </div> */}
                        </div>

                        {/* Right 6 columns */}
                        <div className="col-md-4 d-flex justify-content-end">
                          <div className="d-flex gap-2">                       
                            <button
                              className="btn btn-primary common-btn d-inline-flex align-items-center justify-content-center pdf-btn"
                              onClick={() => handleGeneratePDFNew()}
                              title="Download to PDF"
                            >
                              <i className="bi bi-arrow-down-square ctm-btn-sz"></i>
                            </button>

                          </div>
                        </div>
                      </div>

                      <div className='row'>

                        <div className='col-md-6 wdt' >
                          <p>
                            Showing {(currentPage - 1) * 50 + 1}{''}-
                            {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                          </p>
                        </div>
                        <div className='col-md-6 wdt' align='right'>
                          <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                            placeholder="Search..."
                            className='form-control'
                          /></div></div>
                      <div class="table-containerq" style={{ overflowX: 'unset' }}>

                        <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef}>
                          <thead>
                            <tr className="bg-primary">

                              <th onClick={() => handleSort('sl_no')} scope="col" width="6%">
                                Sl No &nbsp; {renderSortIcon('sl_no')}
                              </th>

                              <th onClick={() => handleSort('account_id')} scope="col">
                                PRN/Account ID &nbsp; {renderSortIcon('account_id')}
                              </th>

                              <th onClick={() => handleSort('course_name')} scope="col">
                                Course Name &nbsp; {renderSortIcon('course_name')}
                              </th>

                              {/* <th onClick={() => handleSort('platform')} scope="col">
                                Platform &nbsp; {renderSortIcon('platform')}
                              </th>                        
 
                                <th onClick={() => handleSort('mode')} scope="col">
                                Mode &nbsp; {renderSortIcon('mode')}
                              </th>  */}
                               <th onClick={() => handleSort('application_status')} scope="col">
                                Appilcation Status &nbsp; {renderSortIcon('application_status')}
                              </th> 
                              <th onClick={() => handleSort('grade')} scope="col" className="text-center">
                                Grade&nbsp; {renderSortIcon('grade')}
                              </th>

                           <th onClick={() => handleSort('acquired_credits')} scope="col" className="text-center">
                                Aquired credit&nbsp; {renderSortIcon('acquired_credits')}
                              </th>

                             
                              <th scope="col" className="text-center">
                                Action
                              </th>
                            </tr>
                          </thead>
                         
<tbody>
  {filteredAndSortedData.length > 0 ? (
    filteredAndSortedData.map((item, index) => (
      <tr key={`${item.account_id}-${index}`}>
        {/* Sl No */}
        <td>{(currentPage - 1) * 50 + index + 1}</td>

        {/* PRN / Account ID */}
        <td>{item.account_id}</td>

        {/* Course Name */}
        <td>{item.course_name}</td>

        {/* Platform */}
        {/* <td>{item.platform}</td>
        <td>{item.mode}</td> */}

        {/* Mode / Application Status */}
        <td>
          {item.application_status === "" || item.application_status === null ? (
            <span className="badge bg-warning text-dark">Pending</span>
          ) : item.application_status === "forwarded_to_sfa" ? (
            <span className="badge bg-blue-clr">Forwarded to SFA</span>
          ) : item.application_status === "forwarded_to_principal" ? (
            <span className="badge bg-success">Forwarded to Principal</span>
          ) : item.application_status === "forwarded_to_university" ? (
            <span className="badge bg-success">Forwarded to University</span>
          ) : item.application_status === "forwarded_to_bos" ? (
            <span className="badge bg-success">Forwarded to BOS</span>
          ) : item.application_status === "rejected_to_candidate" ? (
            <span className="badge bg-danger">SFA Reverted</span>
          ) : (
            <span className="badge bg-secondary">N/A</span>
          )}
        </td>

        {/* Grade */}
        <td className="text-center">{item.grade ?? "-"}<br/>
        {item.grade_point ?? "-"}</td>

        {/* Acquired Credits */}
        <td className="text-center">{item.acquired_credits ?? "-"} <br/>{item.percentage ?? "-"}</td>

        {/* Action */}
        <td>
          <div className="d-flex gap-3 justify-content-center int-action-icons">
            {/* Forward */}
            {item.application_status === "forwarded_to_principal" ? (
              <i
                className="bi bi-send-fill int-forward-icon icn-out-bod"
                title="Already forwarded to Principal"
                onClick={() => toast.info("Already forwarded")}
                style={{ opacity: 0.6, cursor: "not-allowed" }}
              ></i>
            ) : item.application_status === "forwarded_to_sfa" ? (
              <i
                className="bi bi-send-fill int-forward-icon icn-out-bod"
                title="Forward to Principal"
                onClick={() => showConfirm(item.account_id)}
              ></i>
            ) : null}

            {/* Reject */}
            {item.application_status === "rejected_to_candidate" ? (
              <i
                className="bi bi-x-circle-fill int-reject-icon icn-out-bod"
                title="Already rejected"
                onClick={() => toast.info("Already rejected")}
                style={{ opacity: 0.6, cursor: "not-allowed" }}
              ></i>
            ) : item.application_status === "forwarded_to_sfa" ? (
              <i
                className="bi bi-x-circle-fill int-reject-icon icn-out-bod"
                title="Reject to Student"
                onClick={() => showRejectConfirm(item.account_id)}
              ></i>
            ) : null}
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">No data found</td>
    </tr>
  )}
</tbody>

                        </table>
                      </div>

                      {totalPages > 1 && (
                        <nav aria-label="..." style={{ cursor: "pointer" }}>
                          <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                            </li>
                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                            </li>
                            {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                            {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                              <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                              </li>
                            ))}
                            {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                            </li>

                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                            </li>
                          </ul>
                        </nav>
                      )}


                      {/*  Delete User */}
                      <div className={`modal fade show ${getConfirm ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">
                                {/* <ul className="modal-img">
                                  <li> <img src={logo} /></li>
                                </ul> */}
                                <h4 className="text-center pb-2">Are you sure you want to Approve?</h4>
                                <p className="text-center">This action cannot be undone.</p>
                                <div className="d-flex justify-content-center mt-3">
                                  <button className="btn btn-danger mx-2" onClick={() => handleApprove()}>Confirm Approve</button>
                                  <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleCancel()}>Cancel</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  Delete User End */}

                      <div className={`modal fade show ${rejectConfirm ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">
                                {/* <ul className="modal-img">
                                  <li> <img src={logo} /></li>
                                </ul> */}
                                <h4 className="text-center pb-2">Are you sure you want to Reject?</h4>
                                <p className="text-center">This action cannot be undone.</p>
                                <div className="d-flex justify-content-center mt-3">
                                  <button className="btn btn-danger mx-2" onClick={() => handleReject()}>Confirm Reject</button>
                                  <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleRejectCancel()}>Cancel</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>




                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



      </Template>
    </>
  );
}
